import { generateUnOrderedList, getCircleTypeListItem } from "../../../screens/JaldiLab/Chapters/ChapterList";

export const FigureDesc76 = {
    title: "Figure 76: Steps to be taken to ensure implementation of management policies.",
    para1: <>
        <p>
            This figure depicts the policies and strategies that may be put in place to implement the recommendations provided in this Handbook. This is done through three figures showing the “Action Stage”, “Processes and Implementation” and “Monitoring and Evaluation”. The three figures have been described one after the other.
        </p>
        <p>
            The first figure shows the steps involved at the Action stage. The figure depicts three aspects:
            <div className="figure_desc">
                {generateUnOrderedList([
                    `The first box is titled “What?” and is explained as the “Policy type, scope & targets”`,
                    `The second box is titled “How?” and is explained as the “Implementation Plan”`,
                    `The third box is titled “Who?” and is explained as the “Institutional arrangements”`,
                ])}
            </div>
        </p>

        <p>
            The second figure shows the aspects of Process & Implementation. These are depicted in 5 steps:
            {getCircleTypeListItem([
                "Commitment",
                "Assessment",
                "Development",
                "Implementation",
                "Monitoring and Reporting",

            ], false, "1")}
        </p>

        <p>
            The third figure depicts the steps to be taken for implementation of management policies in eight steps
        </p>

        <p>
            The boxes are depicted alternatively on either side of the line for each stage. There are four boxes on each side. The boxes for even numbered steps are depicted on the left side of the line and the boxes for the odd numbered steps are depicted on the right side of the line.
            {generateUnOrderedList([
                `The first box on the right is titled “User Experience surveys” and is explained as “Periodic surveys at post -occupancy stage to assess the design and functioning of Court Complex”.`,
                `The second box on the left is titled “Periodic re-assessments” and is explained as “Regular evaluation should be carried out by expert committees set by the High Courts”.`,
                `The third box on the right is titled “Regular Audits” and is explained as “Conducted regarding the infrastructure, Environment and service delivery method within the court complex”.`,
                `The fourth box on the left is titled “Remediation measures” and is explained as “Implementing Action plan based on audit findings to address the identified barriers to accessibility”.`,
                `The fifth box on the right is regarding  “Training and Awareness: Of the staff members on accessibility guidelines & practices around inclusive design”.`,
                `The sixth box on the left is regarding  “Regular Inspections: Of the environment to identify any new barriers that may arise over time”.`,
                `The seventh box on the right is titled “Implement maintenance protocols” and is explained as “Ensuring accessibility features, such as ramps,lifts, etc are functioning properly over time”.`,
                `The eighth box on the left is regarding “Feedback mechanisms: Such as suggestion boxes or online portals, to allow users to report their concerns or provide their input”.`

            ])}
        </p>
    </>
}

